import { summaryFailureLabel } from '../../supabase/functions/_shared/activityDetails'
import { Badge } from './ui/badge'

export interface SummaryMetadata {
  summary_status?: 'ready' | 'pending' | 'unavailable' | null
  summary_attempts?: number | null
  summary_last_attempt_at?: string | null
  summary_error?: string | null
}

export function ActivitySummaryStatus({ activity, detailed = false }: { activity: SummaryMetadata; detailed?: boolean }) {
  const status = activity.summary_status
  if (!status || status === 'ready') return null
  const attempts = activity.summary_attempts ?? 0
  const attention = status === 'unavailable' || attempts >= 3
  const label = attention ? 'Summary needs attention' : 'Summary pending'
  const explanation = status === 'unavailable' ? 'No retry details were recorded for this older entry.' : summaryFailureLabel(activity.summary_error)
  const lastAttempt = activity.summary_last_attempt_at
  return (
    <div className={detailed ? 'block space-y-2' : 'inline-flex'} role="status">
      <Badge variant="outline" className={attention ? 'border-warning/40 text-warning' : 'text-muted-foreground'} title={explanation}>{label}</Badge>
      {detailed && <span className="block text-xs leading-relaxed text-muted-foreground">
        {explanation}{attempts > 0 && <> {attempts} {attempts === 1 ? 'attempt' : 'attempts'}.</>}
        {lastAttempt && <> Last attempt: <time dateTime={lastAttempt}>{new Date(lastAttempt).toLocaleString()}</time>.</>}
        {status === 'pending' && attempts > 0 && <> Ask the owner to sync this connector again. Queued reports retry with the updated connector; there is no background retry.</>}
        {status === 'pending' && attempts === 0 && <> Retry details were not recorded for this older entry. Ask the owner to update and sync the connector.</>}
      </span>}
    </div>
  )
}
